import { request } from "./request";

const BASE_URL = "/api/projects";

export default {
  async fetchAll() {
    return await request({ url: BASE_URL });
  },

  async fetchAllForAdmin() {
    return await request({ url: `${BASE_URL}?all=true` });
  },

  async fetch(id) {
    return await request({ url: `${BASE_URL}/${encodeURIComponent(id)}` });
  },

  async fetchForUpdate(id) {
    return await request({
      url: `${BASE_URL}/${encodeURIComponent(id)}/edit`,
    });
  },

  async fetchCreateConfig() {
    return await request({ url: `${BASE_URL}/create_config` });
  },

  async create(data) {
    return await request({
      method: "POST",
      url: `${BASE_URL}`,
      data,
    });
  },

  async update(projectId, data) {
    return await request({
      method: "PUT",
      url: `${BASE_URL}/${encodeURIComponent(projectId)}`,
      data,
    });
  },

  async deleteProject(project_id) {
    return await request({
      method: "DELETE",
      url: `${BASE_URL}/${project_id}`,
    });
  },

  async createRequestViaLink(link) {
    return await request({
      method: "POST",
      url: `${BASE_URL}/request_with_link`,
      data: { link },
    });
  },

  async createRequestViaPdf(file) {
    const formData = new FormData();
    formData.append("pdf", file);
    return await request({
      method: "POST",
      url: `${BASE_URL}/request_with_pdf`,
      data: formData,
    });
  },

  async addTalent(project_id, talent_id) {
    return await request({
      method: "PUT",
      url: `${BASE_URL}/${project_id}/talents/${talent_id}`,
    });
  },

  async removeTalent(project_id, talent_id) {
    return await request({
      method: "DELETE",
      url: `${BASE_URL}/${project_id}/talents/${talent_id}`,
    });
  },

  async projectsForTalent(talent_id) {
    return await request({
      url: `/api/project_talents/${talent_id}`,
    });
  },
};
